import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth21postPostScreenTruthSecretsResponseSchema = jsonObject
export type tcpscreentruth21postPostScreenTruthSecretsResponse = z.infer<typeof tcpscreentruth21postPostScreenTruthSecretsResponseSchema>
